import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Advisors, AdvisorState } from './state';

const defaultAdvisorState: AdvisorState = {
  advisors: {},
  loading: true,
  error: null
};

export const advisorsSlice = createSlice({
  name: 'advisors',
  initialState: defaultAdvisorState,
  reducers: {
    fetchAdvisorsSuccess: (state, { payload }: PayloadAction<Advisors>) => ({
      ...state,
      advisors: payload,
      loading: false,
      error: null
    }),
    fetchAdvisorsFailure: (state, { payload }: PayloadAction<string>) => ({
      ...state,
      loading: false,
      error: payload
    })
  }
});

export const { fetchAdvisorsSuccess, fetchAdvisorsFailure } = advisorsSlice.actions;

export const reducer = advisorsSlice.reducer;
